/* eslint-disable @next/next/no-img-element */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { Fragment, useEffect } from "react";
import { useRecoilState, useRecoilValue } from "recoil";
import { evaluationAtom } from "@_recoil/_state";
import styles from "./evaluation_specialization.module.scss";

const EvaluationSpecialization = () => {
  const { specializations } = useRecoilValue(evaluationAtom);
  const [
    { specializationId, is_loading },
    setSpecializationId,
  ] = useRecoilState(evaluationAtom);

  //handle specialization selection
  const handleSpecialization = (event) => {
    //get target value
    const { value, checked } = event.target;

    //when unchecked remove form selected
    if (!checked) {
      setSpecializationId((prev) => ({
        ...prev,
        specializationId: "",
        departmentIds: [],
      }));
      return false;
    }

    if (checked) {
      setSpecializationId((prev) => ({
        ...prev,
        specializationId: parseInt(value),
        departmentIds: [],
      }));
    }
  };

  //handle button
  useEffect(() => {
    setSpecializationId((prev) => ({
      ...prev,
      show_next: specializationId ? true : false,
    }));
  }, [specializationId]);

  return (
    <Fragment>
      <div className={styles.title_wrapper}>
        <div className={styles.title}>Which Field Do You Wish to Study?</div>
      </div>
      {specializations && specializations?.length > 0 && (
        <div className={styles.content}>
          <ul>
            {specializations &&
              specializations.map((sp, i) => {
                return (
                  <li key={`${sp?.slug}_${i}`}>
                    <label
                      htmlFor={sp?.slug}
                      className={
                        sp.specializationId == specializationId
                          ? styles.checked
                          : ""
                      }
                    >
                      <input
                        style={{ display: "none" }}
                        type="radio"
                        id={sp?.slug}
                        name="sp"
                        onChange={handleSpecialization}
                        value={sp?.specializationId}
                        checked={
                          sp.specializationId == specializationId ? true : false
                        }
                      />
                      {sp?.icon && sp?.icon.src && (
                        <div className={styles.icon}>
                          <img
                            src={sp?.icon.src}
                            alt={sp?.icon.alt}
                            width={30}
                            height={30}
                          />
                        </div>
                      )}
                      <div className={styles.name}>{sp.shortName ?? ""}</div>
                    </label>
                  </li>
                );
              })}
          </ul>
        </div>
      )}
    </Fragment>
  );
};

export default EvaluationSpecialization;
